import { Col, Row } from 'react-bootstrap';
import CurrencyField from '../../../benefit/fields/CurrencyField';
import { MAX_WINTER_HELP_PLEDGE, MIN_PLEDGE } from '../../../../constants/constants';

const EditableWinterHelpBenefit = ({ pledgeAmount, onPledgeAmountChange, isSubmitting }) => {

  return (
    <>
      <Row className="mt-3">
        <Col md={6}>
          <CurrencyField
            value={pledgeAmount}
            min={MIN_PLEDGE}
            max={MAX_WINTER_HELP_PLEDGE}
            fieldName="Pledge Amount"
            onChange={onPledgeAmountChange}
            isSubmitting={isSubmitting}
            required
          />
        </Col>
      </Row>
    </>
  );
};

export default EditableWinterHelpBenefit;